/* eslint-disable import/no-absolute-path */
import { type FC } from 'react'
import '/public/icons/search.svg'
import '/public/icons/cross-sml.svg'
import '/public/icons/cross-sml-white.svg'
import '/public/icons/cross-lrg.svg'
import '/public/icons/arrow-horizontal.svg'
import '/public/icons/arrow-vertical.svg'
import '/public/icons/tick.svg'
import '/public/icons/list.svg'
import '/public/icons/map-pin.svg'
import '/public/icons/logo-full.svg'
import '/public/icons/logo-round.svg'
import '/public/icons/logo-invert.svg'
import '/public/icons/search-cross.svg'

interface IconProps {
  name: string;
  className?: string;
}

export const Icon: FC<IconProps> = ({ name, className }) => (
  <svg aria-hidden="true" className={className}>
    <use xlinkHref={name} />
  </svg>
)
